import { Injectable, InjectionToken } from '@angular/core';
import { OccShopConverter } from '@core/utils';
import { Converter } from '@spartacus/core';
import { OccTrackingPickup, TrackingPickup } from '@tracking/const';

@Injectable({ providedIn: 'root' })
export class OccTrackingPickupNormalizer
  extends OccShopConverter
  implements Converter<OccTrackingPickup, TrackingPickup>
{
  convert(source: OccTrackingPickup, target?: TrackingPickup): TrackingPickup {
    if (target === undefined) {
      target = {
        ...(source as any),
      };
    }

    if (target && target.posAddress) {
      target.posAddress = {
        ...source.posAddress,
        formattedAddress: this.addressFormattedNormalize(source.posAddress),
      };
    }

    return target;
  }
}

export const TRACKING_PICKUP_NORMALIZER = new InjectionToken<Converter<OccTrackingPickup, TrackingPickup>>(
  'TrackingPickupNormalizer',
);
